// import localeSlice from "../actions/locale";
import permissionSlice from "../actions/permissions";

const rootReducer = {
  // Locale: localeSlice,
  Permission: permissionSlice,
};

export default rootReducer;
